export const GRAPH_COLORS = {
  currentPortfolio: '#7B73E4',
  recommendedPortfolio: '#FFA32C',
  benchmark: '#00B186',
};
